// src/components/krums/ReclamoDiario.js
import React, { useState } from 'react';
import { reclamarKrumsDiarios } from '../../services/api';

const ReclamoDiario = ({ onReclamar }) => {
  const [reclamado, setReclamado] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleReclamo = async () => {
    setCargando(true);
    setMensaje('');
    
    try {
      const response = await reclamarKrumsDiarios();
      console.log('📥 Respuesta:', response.data);
      
      if (response.data.success) {
        setReclamado(true);
        setMensaje('✅ ¡5 Krums añadidos a tu crisol!');
        
        // Actualizar el saldo en el padre si existe
        if (onReclamar) onReclamar(response.data.krums_gratis);
        
        // Opcional: recargar después de 2 segundos para que vea el mensaje
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      console.error('❌ Error:', error);
      setMensaje('❌ Error al reclamar. Intenta Mañana!.');
      setCargando(false);
    }
  };

  // Si ya reclamó hoy (por estado o por respuesta del backend)
  if (reclamado) {
    return (
      <div className="reclamo-diario completado">
        <p>✅ ¡Krums reclamados con éxito!</p>
        <p className="mensaje-exito">Recarga la página para ver tu nuevo saldo.</p>
      </div>
    );
  }

  return (
    <div className="reclamo-diario">
      <p>✨ Recibe 5 Krums gratis cada día (solo para texto)</p>
      
      {mensaje && <div className="mensaje-flotante">{mensaje}</div>}
      
      <button 
        onClick={handleReclamo} 
        disabled={cargando} 
        className={`btn-reclamar ${cargando ? 'cargando' : ''}`}
      >
        {cargando ? 'Reclamando...' : 'Reclamar Krums diarios'}
      </button>
    </div>
  );
};

export default ReclamoDiario;